import { render, staticRenderFns } from "./enrollment-table-input.vue?vue&type=template&id=21828ccd&scoped=true&"
import script from "./enrollment-table-input.ts?vue&type=script&lang=ts&"
export * from "./enrollment-table-input.ts?vue&type=script&lang=ts&"
import style0 from "./enrollment-table-input.scss?vue&type=style&index=0&id=21828ccd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21828ccd",
  null
  
)

export default component.exports